import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { Text } from 'src/onboarding/components/typography/Text/Text';

export const BenefitsComponent = () => {
  const benefits = [
    {
      icon: '🧭',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.easyToFollow'),
    },
    {
      icon: '🎯',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.tailoredToGoals'),
    },
    {
      icon: '👟',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.adaptedToRoutine'),
    },
    {
      icon: '🥗',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.recipesMatchPreferences'),
    },
    {
      icon: '🪂',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.noDiets'),
    },
    {
      icon: '✍️',
      title: t('onboarding.personalPlanGraphWithVideo.benefits.createdByNutritionists'),
    },
  ];

  return (
    <>
      <Title tag='h4' className={styles.listTitle}>
        {t('onboarding.personalPlanGraphWithVideo.benefitsOf')}
        <span> {t('onboarding.personalPlanGraphWithVideo.yourPlan')}</span>
      </Title>
      <div className={styles.reachYourGoal}>
        {benefits.map((item, index) => (
          <div className={styles.reachYourGoalItem} key={index}>
            <Text>{item.icon}</Text>
            <Text className={styles.benefitsText}>{item.title}</Text>
          </div>
        ))}
      </div>
    </>
  );
};
